const ThirdPartyApprovalActionTypes = {
  UNCHECK_ALL: "UNCHECK_ALL",
  SET_APPROVED_ASSETS: "SET_APPROVED_ASSETS",
  ADD_APPROVED_ASSET: "ADD_APPROVED_ASSET",
  REMOVE_APPROVED_ASSET: "REMOVED_APPROVED_ASSET",
}

export default ThirdPartyApprovalActionTypes
